const $ = jQuery.noConflict();
// import Global from './global';

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.inputTypeNoLettersIE();
	},

	inputTypeNoLettersIE: function() {
		$('.wpcf7-number').bind({
            keydown: function(e) {
                if (e.shiftKey === true ) {
                    if (e.which == 9) {
                        return true;
                    }
                    return false;
                }
                if (e.which > 57) {
                    return false;
                }
                if (e.which==32) {
                    return false;
                }
                return true;
            }
        });
	},
};

export default Header;